<template>
  <div class="a-service-container">
    <mypacks-search
      v-if="myPackList"
      @search-options-change="searchOptionsChange"
    />
    <mypacks-common-title
      v-if="myPackList"
      :num-of-pack="totalNumOfPacks"
      @delete-selection="onDeleteSelection"
      @click-composition="onClickComposition"
    />
    <div class="box_coupon-group" v-if="myPackList">
      <mypacks-item
        v-for="(packItem, index) in myPackList"
        :key="index"
        :pack-item="packItem"
        @item-state-change="onItemStateChange"
        @confirm="onItemStateChange"
        @item-check-state-change="onItemCheckStateChange"
        @on-cancel-order="onCancelOrder"
        @on-reorder="onReorder"
      />
      <div class="btn_more">
        <button v-if="moreListBtn" type="button" @click="showMoreList">
          더보기
        </button>
      </div>
    </div>
    <div class="msg_box">
      <mypack-no-search v-if="!existSearchPackList" />
      <mypack-no-content v-else-if="!existPackList" />
    </div>

    <modal-confirm
      ref="refModalConfirm"
      text="선택한 마이팩을 삭제하시겠습니까?"
      sub-text="[주의] 삭제시 복구나 조회가 되지 않습니다."
      @confirm="onConfirmDeleteMypacks"
    />
    <modal-reorder-request
      ref="refReorderModal"
      :purchase-type="purchaseType"
      :req-no="reqNo"
      :mypack-name="mypackName"
      :is-order-payment="isOrderPayment"
    />
    <modal-cancel-order
      ref="refCancelOrderModal"
      :order-info="orderInfo"
      :order-key="orderKey"
      @confirm="searchPackList"
    />
    <modal-alert ref="refAlert" />
  </div>
</template>

<script>
import { log } from "@/utils/common";
import { PACK_STATUS_CODE } from "@/utils/constants";
import packApi from "@/apis/pack";
import compositionHelpers from "@/utils/helpers/composition";

import MypackNoContent from "./MypackNoContent.vue";
import MypackNoSearch from "./MypackNoSearch.vue";
import MypacksCommonTitle from "./MypacksCommonTitle.vue";
import MypacksItem from "./MypacksItem.vue";
import MypacksSearch from "./MypacksSearch.vue";
import ModalReorderRequest from "@/components/modal-popups/ModalReorderRequest.vue";
import ModalCancelOrder from "@/components/modal-popups/ModalCancelOrder.vue";
import ModalAlert from "@/components/global/ModalAlert.vue";
import ModalConfirm from "@/components/global/ModalConfirm.vue";

const DISPLAY_MORE_LIST_BTN = 12;

export default {
  components: {
    MypacksCommonTitle,
    MypacksSearch,
    MypacksItem,
    MypackNoSearch,
    MypackNoContent,
    ModalReorderRequest,
    ModalCancelOrder,
    ModalAlert,
    ModalConfirm,
  },
  name: "MypacksTabContents",
  props: {
    purchaseType: {
      type: String,
      required: true,
    },
    packList: {
      type: Array,
      required: true,
      default: [],
    },
    packCount: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  data() {
    return {
      myPackList: [],
      searchOptions: {
        searchText: "",
        searchStatus: "",
      },
      totalNumOfPacks: 0,
      pageNum: 1,
      moreListBtn: false,
      existPackList: true,
      existSearchPackList: true,
      checkedGroup: [],

      orderList: null,
      productsDetails: [],
      soldoutProducts: [],
      soldoutSkus: [],
      endOfSaleSkus: [],
      reCalDoseInfo: [],
      curSeq: 0,
      runCheckout: false,

      // 재주문
      reqNo: 0,
      mypackName: "",

      // 주문 취소
      orderInfo: {},
      orderKey: "",
      isOrderPayment: false
    };
  },
  watch: {
    packList(packList) {
      this.myPackList = packList;
      // this.totalNumOfPacks = this.myPackList.length;
      this.existPackList = this.myPackList.length > 0;
      this.checkedGroup = [];
    },
    packCount(packCount) {
      // this.myPackList = packList;
      this.totalNumOfPacks = packCount;
      // this.existPackList = this.myPackList.length > 0;
      // this.checkedGroup = [];

      if (this.totalNumOfPacks > DISPLAY_MORE_LIST_BTN) {
        this.moreListBtn = true;
      } else {
        this.moreListBtn = false;
      }

    },
  },
  computed: {},
  methods: {
    async onConfirmDeleteMypacks() {
      log(
        "Mypacks::onConfirmDeleteMypacks",
        "deleting reqs",
        this.checkedGroup
      );
      const r = await packApi.deleteSelectedMypacks(this.checkedGroup);
      if (r.error) {
        return;
      }
      await this.$refs.refAlert.openWithMessage(
        "선택하신 마이팩이 정상 삭제되었습니다."
      );

      this.$emit("update-pack-count");
      this.searchPackList();
    },
    async onClickComposition() {
      // 주문서 생성 제한 해제
      // if (!(await compositionHelpers.checkMypackLimit(this.$refs.refAlert))) {
      //   return;
      // }
      this.$router.push("/");
    },
    async searchPackList() {
      const r = await packApi.getPagedOrderInfo(
        this.searchOptions.searchText,
        this.pageNum,
        this.searchOptions.searchStatus,
        this.purchaseType
      );
      this.myPackList = r.packList; // todo remove
      this.totalNumOfPacks = r.totalCount;

      // this.$emit('update-pack-list')

      if (this.totalNumOfPacks > DISPLAY_MORE_LIST_BTN) {
        this.moreListBtn = true;
      } else {
        this.moreListBtn = false;
      }
      if (this.totalNumOfPacks === 0) {
        this.existSearchPackList = false;
      } else {
        this.existSearchPackList = true;
      }
    },
    searchOptionsChange(val) {
      this.checkedGroup = [];
      this.searchOptions = val;
      this.pageNum = 1;
      this.searchPackList();
    },
    async showMoreList() {
      // scroll to scroll-bottom-target
      const justToItemIdx = this.myPackList.length;

      this.pageNum += 1;
      const moreList = await packApi.getPagedOrderInfo(
        this.searchOptions.searchText,
        this.pageNum,
        this.searchOptions.searchStatus,
        this.purchaseType
      );
      moreList.packList.forEach((n) => {
        this.myPackList.push(n);
      });
      if (this.totalNumOfPacks > DISPLAY_MORE_LIST_BTN * this.pageNum) {
        this.moreListBtn = true;
      } else {
        this.moreListBtn = false;
      }

      setTimeout(() => {
        const targetId = `target-${this.myPackList[justToItemIdx].reqNo}`;
        const scrollTarget = document.getElementById(targetId);
        scrollTarget.scrollIntoView({
          behavior: "smooth",
        });
      }, 0);
    },
    async onDeleteSelection() {
      log(
        "Mypacks::onDeleteSelection",
        "final selected reqs",
        this.checkedGroup
      );
      if (this.checkedGroup.length === 0) {
        await this.$refs.refAlert.openWithMessage(
          "삭제할 마이팩을 선택해 주세요."
        );
        return;
      }

      await this.$refs.refModalConfirm.open();
    },
    onItemStateChange() {
      this.searchPackList();
    },
    async onItemCheckStateChange(payload) {
      this.checkedGroup = [];
      this.checkedGroup.push(payload.reqNo);
      log(
        "Mypacks::onItemCheckStateChange",
        "selected reqs",
        this.checkedGroup
      );
      await this.$refs.refModalConfirm.open();
    },
    async onReorder(e) {
      this.reqNo = e.reqNo;
      this.mypackName = e.mypackName;

      // 기존 팩이 승인이 안된 상태라면 마이팩 3단계로 이동
      if(!e.consulted) {
        const r = await packApi.getApplianceDetail(e.reqNo, true);
        if (r.error) {
          return;
        }
        this.isOrderPayment = r.order_payment.length > 0;

        const {
          req_no,
          take_days,
          purchase_type,
          abc_cd,
          cfm_kind,
          billing_date,
          billing_status,
          consulted,
        } = r.order_info[0];

        // 조회한 팩 상태가 승인 상태라면 재주문 레이어 팝업 수행
        if (consulted) {
          await this.$refs.refReorderModal.open();
          return;
        }

        const subscription = {
          purchaseType: purchase_type,
          abcCd: abc_cd,
          requestType: cfm_kind,
          billingDate: billing_date,
          billingStatus: purchase_type == 'recurring' ? 'ACTIVE' : '',
          isConsultation: false,
        };

        const finalSkus = r.order_detail_list.map((n) => ({
          days: take_days,
          item_sku: n.item_sku,
          pockets: n.dose,
          seq: n.dose_list,
        }));

        const reqNo = req_no;
        await compositionHelpers.doReorderFromMypack(
          this.$store,
          r,
          subscription,
          finalSkus,
          reqNo
        );
        await this.$router.push("/agreement/composition-reorder");
      }
      // 승인이 된 경우 재주문 레이어 팝업 실행
      else {
        await this.$refs.refReorderModal.open();
      }
    },
    onCancelOrder(e) {
      this.orderInfo = e.orderInfo;
      this.orderKey = e.orderKey;
      this.$refs.refCancelOrderModal.open();
    },
  },
};
</script>
<style scoped>
/* .box_coupon-group {
  padding-bottom: 4px;
}

.btn_more {
  position: relative;
  left: 0;
} */
</style>
